(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mg-home-editorial"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(root){
    root.querySelectorAll('.mg-home').forEach(function(home){
      if(home.dataset.railReady)return;
      home.dataset.railReady='true';
      var rail=home.querySelector('.mg-home__rail'),arrows=home.querySelector('.mg-home__arrows');
      if(!rail||!arrows)return;
      var buttons=arrows.querySelectorAll('button');
      function state(){arrows.hidden=rail.scrollWidth<=rail.clientWidth+3;buttons[0].disabled=rail.scrollLeft<3;buttons[1].disabled=rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-3;}
      buttons.forEach(function(button){button.addEventListener('click',function(){var card=rail.querySelector('.mg-home__card');var gap=parseFloat(getComputedStyle(rail).gap)||18;var step=card.getBoundingClientRect().width+gap;var count=Math.max(1,Math.floor((rail.clientWidth+gap)/step));rail.scrollBy({left:Number(button.dataset.mgDirection)*step*count,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});});
      rail.addEventListener('scroll',state,{passive:true});
      var observer=new ResizeObserver(state);
      observer.observe(rail);
      function unload(event){if(event.target.contains(home)){observer.disconnect();document.removeEventListener('shopify:section:unload',unload);}}
      document.addEventListener('shopify:section:unload',unload);
      state();
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load',function(event){setup(event.target);});
})();

(function(){
  function init(root){
    root.querySelectorAll('.mg-cinema').forEach(function(hero){
      if(hero.dataset.videoReady)return;
      hero.dataset.videoReady='true';
      var video=hero.querySelector('video'),button=hero.querySelector('.mg-cinema__toggle');
      if(!video||!button)return;
      var reduced=matchMedia('(prefers-reduced-motion: reduce)'),mobile=matchMedia('(max-width: 749px)'),connection=navigator.connection;
      var paused=false,started=false,inView=false,failed=false,activeSource='';
      try{paused=sessionStorage.getItem('mg-cinema-paused')==='true';}catch(e){}
      function label(){button.textContent=video.paused?button.dataset.play:button.dataset.pause;}
      function source(){return mobile.matches&&video.dataset.mobileSrc?video.dataset.mobileSrc:video.dataset.src;}
      function mayAutoplay(){return inView&&!document.hidden&&!paused&&!reduced.matches&&!(connection&&connection.saveData)&&!failed;}
      function load(){
        var next=source();
        if(!started||activeSource!==next){
          video.classList.remove('is-playing');
          video.src=next;video.muted=true;video.load();
          activeSource=next;started=true;failed=false;button.hidden=false;
        }
      }
      function play(){load();video.play().catch(label);}
      button.hidden=false;
      video.addEventListener('playing',function(){video.classList.add('is-playing');label();});
      video.addEventListener('pause',label);
      video.addEventListener('error',function(){failed=true;video.classList.remove('is-playing');button.hidden=true;});
      button.addEventListener('click',function(){paused=!video.paused;try{sessionStorage.setItem('mg-cinema-paused',String(paused));}catch(e){}if(paused){video.pause();}else{play();}});
      function motionChanged(){
        if(reduced.matches){video.pause();video.classList.remove('is-playing');}
        else if(mayAutoplay()){play();}
      }
      function sourceChanged(){
        if(!started||source()===activeSource)return;
        video.pause();video.classList.remove('is-playing');
        video.removeAttribute('src');video.load();
        activeSource='';started=false;failed=false;button.hidden=false;label();
        if(mayAutoplay())play();
      }
      function visibilityChanged(){if(document.hidden){video.pause();}else if(mayAutoplay()){play();}}
      reduced.addEventListener('change',motionChanged);
      mobile.addEventListener('change',sourceChanged);
      var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){
        inView=entry.isIntersecting&&entry.intersectionRatio>=.15;
        if(!inView){video.pause();}else if(mayAutoplay()){play();}
      });},{threshold:.15});
      observer.observe(hero);
      document.addEventListener('visibilitychange',visibilityChanged);
      function unload(event){if(event.target.contains(hero)){
        observer.disconnect();video.pause();
        reduced.removeEventListener('change',motionChanged);mobile.removeEventListener('change',sourceChanged);
        document.removeEventListener('visibilitychange',visibilityChanged);document.removeEventListener('shopify:section:unload',unload);
      }}
      document.addEventListener('shopify:section:unload',unload);
      label();
    });
  }
  if(document.readyState==='complete'){init(document);}else{window.addEventListener('load',function(){init(document);},{once:true});}
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();


  } catch(e) { console.error(e); }
})();
})();
